export default "__VITE_ASSET__016482eb__"